export default "__VITE_ASSET__BgWUo1cY__"